import { removeAll } from '@leverege/array-util';
import { pathValue } from '@leverege/object-util';
const optionsMap = {
  ACH: 'ach',
  'Wire Transfer': 'wire-transfer',
  Check: 'check',
  Cash: 'cash'
};
export default {
  id: 'recovr.payments.BulkCreate',
  name: 'Bulk Create Payments Hook',
  matches: {
    objectType: 'payment'
  },
  hook(devs, props) {
    return devs.map(dev => {
      if (dev instanceof Error) {
        return dev;
      }
      const {
        data
      } = dev;
      const type = pathValue(data, 'type');
      const d = replaceType(data, type);
      return {
        ...dev,
        data: [...d]
      };
    });
  }
};

// function replaceValue( data, value, path ) {
//   const nData = [ ...data ]
//   const len = nData.length
//   for ( let i = 0; i < len; i++ ) {
//     if ( nData[i].path === path ) {
//       nData[i] = { path, value }
//       break
//     }
//   }

//   return nData
// }

function replaceType(data, type) {
  const trimmed = type?.trim();
  const typeVal = optionsMap[trimmed];
  if (type && typeVal) {
    const nData = [...data];
    const len = nData.length;
    for (let i = 0; i < len; i++) {
      if (nData[i].path === 'type') {
        nData[i] = {
          path: 'type',
          value: typeVal
        };
        break;
      }
    }
    return nData;
  }
  removeAll(data, 'path', 'type');
  return data;
}